import { render, staticRenderFns } from "./YUserDetail.vue?vue&type=template&id=7aac8a8e&scoped=true&"
import script from "./YUserDetail.vue?vue&type=script&lang=js&"
export * from "./YUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./YUserDetail.vue?vue&type=style&index=0&id=7aac8a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aac8a8e",
  null
  
)

export default component.exports